import React, { useState } from "react";

import EyeIcon from "../../../assets/icons/EyeIcon";
import EditIcon from "../../../assets/icons/EditIcon";

import NoDataIcon from "../../../assets/icons/NoDataIcon";
import ProductLinkIcon from "../../../assets/product-link.svg";
import { useSelector } from "react-redux";
import ProductLinkModal from "./ProductLinkModal";
import "../../../style/product.css";

const ProductTable = ({ products, onView, onEdit, onDelete, onProductUpdated }) => {
  const { isPartsURL, isAccessoriesURL, isGodownURL } = useSelector((state) => state.domain);
  const isLoycomDomain =
    window.location.hostname === process.env.REACT_APP_WEB_LOYCOM_URL;
  const [linkProduct, setLinkProduct] = useState(null);
  const showTagColumn = isAccessoriesURL || isGodownURL;
  const columnCount = 7 + (showTagColumn ? 1 : 0) + (isGodownURL ? 1 : 0);

  const displayProducts = products && products.length > 0 ? products : [];

  const getStatusColor = (status) => {
    switch (status) {
      case "out of stock":
        return "#FF5356";
      case "low":
        return "#FE9400";
      case "in stock":
        return "#0CAE00";
      default:
        return "#FF5356";
    }
  };

  const formatProductDetails = (product) =>
    [
      product.ram,
      product.storage,
      product.variants?.map((v) => Object.values(v).join(", ")).join(", "),
      product.suffix,
      product.used_mobile !== undefined && product.used_mobile !== null
        ? product.used_mobile === false
          ? "New"
          : "Used"
        : null,
    ]
      .filter(Boolean)
      .join(" | ");

  const tableClassName = `product-table${isGodownURL ? " product-table-godown" : ""}${
    showTagColumn && !isGodownURL ? " product-table-accessories" : ""
  }`;

  return (
    <>
      <div className="product-table-container">
        <div className="product-table-scroll">
          <table className={tableClassName}>
            <colgroup>
              <col className="col-name" />
              <col className="col-category" />
              {showTagColumn && <col className="col-tag" />}
              <col className="col-buy" />
              <col className="col-sell" />
              <col className="col-stock" />
              {isGodownURL && <col className="col-location" />}
              <col className="col-status" />
              <col className="col-action" />
            </colgroup>
            <thead>
              <tr>
                <th>NAME</th>
                <th>CATEGORY</th>
                {showTagColumn && <th>TAG</th>}
                <th>AVG. BUYING PRICE</th>
                <th>AVG. SELLING PRICE</th>
                <th>IN STOCK</th>
                {isGodownURL && <th>LOCATION</th>}
                <th>STATUS</th>
                <th className="col-action-header">ACTION</th>
              </tr>
            </thead>
            <tbody>
              {displayProducts.length === 0 && (
                <tr>
                  <td colSpan={columnCount} className="no-products-message">
                    <div
                      style={{
                        marginBottom: "4rem",
                        marginTop: "4rem",
                      }}
                    >
                      <NoDataIcon />
                      <h3 style={{ marginTop: "2rem" }}>No Products Found</h3>
                    </div>
                  </td>
                </tr>
              )}
              {displayProducts.map((product) => (
                <tr key={product.id}>
                  <td className="product-name-cell">
                    <div>
                      <div className="product-name-text" title={product.name}>
                        {product.name}
                      </div>
                      <div
                        className="product-name-details"
                        title={formatProductDetails(product)}
                      >
                        {formatProductDetails(product)}
                      </div>
                    </div>
                  </td>
                  <td>{product.category_name || product.category || "N/A"}</td>
                  {showTagColumn && (
                    <td>{product.unique_identifier_identifier || "-"}</td>
                  )}
                  <td>€{parseFloat(product.avg_buying_price || 0).toFixed(2)}</td>
                  <td>
                    €{parseFloat(product.avg_selling_price || 0).toFixed(2)}
                  </td>
                  <td>{product.in_stock || 0}</td>
                  {isGodownURL && <td>{product.location || "-"}</td>}
                  <td className="status-cell">
                    <span
                      className="status-dot"
                      style={{
                        backgroundColor: getStatusColor(product.status),
                      }}
                    ></span>
                  </td>
                  <td className="action-cell">
                    <div className="action-buttons">
                      {!isLoycomDomain && (
                        <button
                          className={`${
                            isPartsURL
                              ? "action-btn-parts view"
                              : isAccessoriesURL
                              ? "action-btn-acc view"
                              : isGodownURL
                              ? "action-btn-godown view"
                              : "action-btn view"
                          }`}
                          onClick={() => setLinkProduct(product)}
                          title="Link"
                        >
                          <img
                            src={ProductLinkIcon}
                            alt="link"
                            style={{ width: 16, height: 16 }}
                          />
                        </button>
                      )}
                      <button
                        className={`${
                          isPartsURL
                            ? "action-btn-parts view"
                            : isAccessoriesURL
                            ? "action-btn-acc view"
                            : isGodownURL
                            ? "action-btn-godown view"
                            : "action-btn view"
                        }`}
                        onClick={() => onView(product)}
                        title="View"
                      >
                        <EyeIcon
                          fill={
                            isPartsURL
                              ? "var(--primary-color-parts)"
                              : isAccessoriesURL
                              ? "var(--primary-color-acc)"
                              : isGodownURL
                              ? "var(--primary-color-godown)"
                              : "#2F80ED"
                          }
                        />
                      </button>
                      {!isAccessoriesURL && (
                        <button
                          className={`${
                            isPartsURL
                              ? "action-btn-parts view"
                              : isGodownURL
                              ? "action-btn-godown view"
                              : "action-btn view"
                          }`}
                          onClick={() => onEdit(product)}
                          title="Edit"
                        >
                          <EditIcon
                            fill={
                              isPartsURL
                                ? "var(--primary-color-parts)"
                                : isGodownURL
                                ? "var(--primary-color-godown)"
                                : "#2F80ED"
                            }
                          />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {linkProduct && (
        <ProductLinkModal
          isOpen={true}
          onClose={() => setLinkProduct(null)}
          product={linkProduct}
          onPriceUpdated={onProductUpdated}
        />
      )}
    </>
  );
};

export default ProductTable;
